import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UserInterface.scss';
import { SiNamemc } from "react-icons/si";
import { FaPercent } from "react-icons/fa";
import data from './data.json';
import FloatingIcon from './FloatingIcon';

const UserInterface = () => {
  const navigate = useNavigate();

  // Gestionnaire pour vérifier si le clic est proche des coins
  const handleContainerClick = (event) => {
    // Récupérer la largeur du conteneur
    const containerWidth = event.currentTarget.offsetWidth;

    // Définir un seuil pour les coins (par exemple 10% de la largeur totale)
    const threshold = containerWidth * 0.1;

    // Vérifier si le clic est dans les 10% du début ou de la fin du conteneur
    if (event.nativeEvent.offsetX < threshold || event.nativeEvent.offsetX > containerWidth - threshold) {
      navigate('/Principal'); // Naviguer vers une nouvelle page
    }
  };

  return (
    <div className="user-interface" onClick={handleContainerClick}>
      {data.map((item) => (
        <div key={item.id} className="user-item">
          <div className="left-column">            
            <div className="item-label">
              <SiNamemc className='icon-g'/>
              {item.label}
            </div>
            <div className="item-rate">{item.rate}</div>
            <div className="item-amount">{item.amount}</div>            
            <div className="item-percentage">
              <FaPercent className='icon-h'/>
              {item.percentage}
            </div>
          </div>
          <div className="right-column">
            <div className="item-rate">{item.rate}</div>
            <div className="item-amount">{item.amount}</div>
            <button
              className="item-button"
              onClick={(e) => {
                e.stopPropagation(); // Empêcher le clic de se propager au conteneur parent
                navigate('/Main');
              }}
            >
              {item.buttonText}
            </button>
          </div>
        </div>
      ))}
      <FloatingIcon />
    </div>
  );
};

export default UserInterface;
